import { mbSize, Media } from '@foxrenderfarm/common'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
`

export const PageButton = styled.div<{
  $disabled?: boolean
  $isActive?: boolean
  $isEllipsis?: boolean
  $noMarginRight?: boolean
}>`
  width: 40px;
  height: 40px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $disabled }) => ($disabled ? '#F7F7F7' : 'unset')};
  margin-right: ${({ $noMarginRight }) => ($noMarginRight ? 0 : '12px')};
  color: ${({ $isActive }) => ($isActive ? '#F3512B' : '#333333')};
  font-weight: ${({ $isActive }) => ($isActive ? 700 : 400)};
  cursor: ${({ $disabled, $isEllipsis }) =>
    $disabled ? 'not-allowed' : $isEllipsis ? 'unset' : 'pointer'};
  svg {
    fill: ${({ $disabled }) => ($disabled ? '#999999' : '#333333')};
  }
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(58)};
    height: ${mbSize(58)};
    margin-right: ${({ $noMarginRight }) => ($noMarginRight ? 0 : mbSize(16))};
    font-size: ${mbSize(24)};
    border-radius: ${mbSize(6)};
  }
`
